import React from "react";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1071_R01Store from "./usePDA1071_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1071_R01Content } from "./PDA1071_R01Content";

import PDA1071_R01Search from "./PDA1071_R01Search";
import PDA1071_R01Table from "./PDA1071_R01Table";
import PDA1071_R01DetailInfo from "./PDA1071_R01DetailInfo";
import PDA1071_R01DetailTable from "./PDA1071_R01DetailTable";

interface Props {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1071_R01Container = ({ menuNm, menuCd, onBack }: Props) => {
  const { loading, reset, showList, workOrderList } = usePDA1071_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);
  const {
    handleSearch,
    handleRefetch,
    handleSelectWorkOrder,
    handleBackToList,
  } = usePDA1071_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={showList ? onBack : handleBackToList}
        onMenuClick={handleMenuClick}
      />

      <div className="flex-1 overflow-hidden">
        {showList ? (
          <div className="h-full flex flex-col">
            <PDA1071_R01Search onSearch={handleSearch} onRefetch={handleRefetch} />
            <div className="flex-1 overflow-hidden">
              <PDA1071_R01Table
                workOrderList={workOrderList}
                onSelectWorkOrder={handleSelectWorkOrder}
              />
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col min-h-0">
            <PDA1071_R01DetailInfo />
            <div className="flex-1 overflow-hidden flex flex-col min-h-0">
              <PDA1071_R01DetailTable />
            </div>
          </div>
        )}
      </div>

      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1071_R01Container;
